import PropTypes from "prop-types";
import React from "react";
import signature from "../../../../assets/img/cachet.png";
import { frenchDateOnly, splitNameStringForPrintingAttestation } from "../../../../variables/functions";

const AttestationTPVToPrint = React.forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      className="position-relative"
      style={{
        height: 400,
        width: 1080,
      }}
    >
      {props?.contrat?.producteur?.agence?.ville == "LOME" && <div className="row">
        <div
          className="col"
          style={{ position: "relative", left: "76px", top: "260px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "20px",
              marginTop: "63px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.souscripteur?.nom}{" "}
              {props.contrat?.souscripteur?.prenom || ""}{" "}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "20px",
              marginTop: "78px",
              fontSize: "12px",
            }}
          >
            <b>{props.contrat?.souscripteur?.contact?.[0] || " "}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "75px",
              marginTop: "95px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "37px",
              marginTop: "110px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "125px",
              marginTop: "110px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "115px",
              marginTop: "126px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "112px",
              marginTop: "143px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "78px",
              marginTop: "160px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "80px",
              marginTop: "176px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || ""}</b>
          </h6>
        </div>
        <div
          className="col"
          style={{ position: "relative", left: "81px", top: "260px" }}
        >
          <h6
            className=""
            style={{
              position: "absolute",
              marginLeft: "-40px",
              marginTop: "98px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-81px",
              marginTop: "115px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "7px",
              marginTop: "115px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-3px",
              marginTop: "132px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-4px",
              marginTop: "150px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-39px",
              marginTop: "165px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-50px",
              marginTop: "181px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "10px",
              marginTop: "198px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.usage || "_"}</b>
          </h6>
        </div>
        <div
          className="col"
          style={{ position: "relative", left: "86px", top: "262px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-82px",
              marginTop: "20px",
              fontSize: "12px",
            }}
          >
            <b>
              {
                splitNameStringForPrintingAttestation(
                  `${props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.nom + " " + props.contrat?.souscripteur?.prenom : props.contrat?.souscripteur?.nom}`,
                  21,
                ).firstLine
              }
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-217px",
              marginTop: "46px",
              fontSize: "12px",
            }}
          >
            <b>
              {
                splitNameStringForPrintingAttestation(
                  `${props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.nom + " " + props.contrat?.souscripteur?.prenom : props.contrat?.souscripteur?.nom}`,
                  21,
                ).secondLine
              }{" "}
              {props.contrat?.souscripteur?.adresse || "_"}{" "}
              {props.contrat?.souscripteur?.contact?.[0] || ""}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-150px",
              marginTop: "64px",
              fontSize: "12px",
            }}
          >
            <b>{props.contrat?.souscripteur?.profession || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-153px",
              marginTop: "81px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-180px",
              marginTop: "107px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-65px",
              marginTop: "107px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-120px",
              marginTop: "128px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-122px",
              marginTop: "145px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-155px",
              marginTop: "162px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-135px",
              marginTop: "180px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || "-"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-55px",
              marginTop: "197px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.usage || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-182px",
              marginTop: "245px",
              fontSize: "12px",
            }}
          >
            <b>App. Terrestre</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-32px",
              marginTop: "245px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-100px",
              marginTop: "260px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "193px",
            }}
          >
            <img style={{ width: "60%" }} src={signature} />
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "253px",
              fontSize: "11px",
            }}
          >
            Imprimée à {props.contrat?.producteur?.agence?.ville} le {props?.contrat?.dateImpressionAttestation ? frenchDateOnly(props?.contrat?.dateImpressionAttestation?.split("T")[0]) : frenchDateOnly(props?.contrat.createdAt?.split("T")[0])}
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "273px",
              fontSize: "11px",
            }}
          >
            par {props.contrat?.producteur?.personne?.nom} {props.contrat?.producteur?.personne?.prenom}
          </h6>
        </div>
      </div>}

      {props?.contrat?.producteur?.agence?.ville == "KPALIME" && (<div className="row">
        <div
          className="col"
          style={{ position: "relative", left: "76px", top: "270px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "20px",
              marginTop: "63px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.souscripteur?.nom}{" "}
              {props.contrat?.souscripteur?.prenom || ""}{" "}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "20px",
              marginTop: "78px",
              fontSize: "12px",
            }}
          >
            <b>{props.contrat?.souscripteur?.contact?.[0] || " "}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "75px",
              marginTop: "95px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "37px",
              marginTop: "110px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "125px",
              marginTop: "110px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "115px",
              marginTop: "126px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "112px",
              marginTop: "143px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "78px",
              marginTop: "160px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "80px",
              marginTop: "176px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || ""}</b>
          </h6>
        </div>
        <div
          className="col"
          style={{ position: "relative", left: "81px", top: "270px" }}
        >
          <h6
            className=""
            style={{
              position: "absolute",
              marginLeft: "-40px",
              marginTop: "98px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-81px",
              marginTop: "115px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "7px",
              marginTop: "115px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-3px",
              marginTop: "132px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-4px",
              marginTop: "150px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-39px",
              marginTop: "165px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-50px",
              marginTop: "181px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "10px",
              marginTop: "198px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.usage || "_"}</b>
          </h6>
        </div>
        <div
          className="col"
          style={{ position: "relative", left: "86px", top: "272px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-82px",
              marginTop: "20px",
              fontSize: "12px",
            }}
          >
            <b>
              {
                splitNameStringForPrintingAttestation(
                  `${props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.nom + " " + props.contrat?.souscripteur?.prenom : props.contrat?.souscripteur?.nom}`,
                  21,
                ).firstLine
              }
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-217px",
              marginTop: "46px",
              fontSize: "12px",
            }}
          >
            <b>
              {
                splitNameStringForPrintingAttestation(
                  `${props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.nom + " " + props.contrat?.souscripteur?.prenom : props.contrat?.souscripteur?.nom}`,
                  21,
                ).secondLine
              }{" "}
              {props.contrat?.souscripteur?.adresse || "_"}{" "}
              {props.contrat?.souscripteur?.contact?.[0] || ""}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-150px",
              marginTop: "64px",
              fontSize: "12px",
            }}
          >
            <b>{props.contrat?.souscripteur?.profession || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-153px",
              marginTop: "81px",
              fontSize: "12px",
            }}
          >
            <b>
              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-180px",
              marginTop: "107px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-65px",
              marginTop: "107px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-120px",
              marginTop: "128px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-122px",
              marginTop: "145px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-155px",
              marginTop: "162px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-135px",
              marginTop: "180px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || "-"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-55px",
              marginTop: "197px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.usage || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-182px",
              marginTop: "245px",
              fontSize: "12px",
            }}
          >
            <b>App. Terrestre</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-32px",
              marginTop: "245px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-100px",
              marginTop: "260px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "183px",
            }}
          >
            <img style={{ width: "60%" }} src={signature} />
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "243px",
              fontSize: "11px",
            }}
          >
            Imprimée à {props.contrat?.producteur?.agence?.ville} le {props?.contrat?.dateImpressionAttestation ? frenchDateOnly(props?.contrat?.dateImpressionAttestation?.split("T")[0]) : frenchDateOnly(props?.contrat.createdAt?.split("T")[0])}
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "263px",
              fontSize: "11px",
            }}
          >
            par {props.contrat?.producteur?.personne?.nom} {props.contrat?.producteur?.personne?.prenom}
          </h6>
        </div>
      </div>)}
    </div>
  );
});
AttestationTPVToPrint.propTypes = {
  contrat: PropTypes.object,
  engin: PropTypes.object,
};
AttestationTPVToPrint.displayName = "Attestation TPV";
export default AttestationTPVToPrint;
